<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div
  class="modal-body">
  @let imageData = getProductImageData();
  @if (imageData) {
    <div
      class="image-product">
      <img
        alt="{{ (imageData.src! | getAltText | async) || props().data.product.longDescription }}"
        class="product-single"
        [lazySrc]="imageData"
      />
    </div>
  }
  <span
    class="added-to-cart-message">
    {{ addedToCartMessage() }}
  </span>
</div>
